import { Box, IconButton } from "@mui/material"
import BottomBar from "./BottomBar"
import DefenceMode from "./DefenceMode"
import OffenceMode from "./OffenceMode"
import SpeedModePage from "./SpeedModePage"
import ComprehensiveMode from "./ComprehensiveMode"
import { POKEMON_ID_GROUDON_PRIMAL, POKEMON_ID_KYOGRE_PRIMAL, POKEMON_ID_RAYQUAZA_MEGA } from "../lib/pokemon-config"
// NOTE: 一時的に型循環/解決不能回避のため any を使用（後で types/ に正式化）
// 画面ごとのVMが共通化できたら型を切り出す
function MainDisplay({ vm }: { vm: any }) {
  const {
    selectedPokemon,
    selectedPokemonForComprehensive,
    pokemonOptions,
    attackPokemonList,
    setAttackPokemonList,
    selectedAttackPokemonForMove,
    setSelectedAttackPokemonForMove,
    rightSidebarOpen,
    currentOtherSetting,
    onOtherSettingChange,
    handleAddAttackPokemon,
    getAllAttackMoves,
    handleSelectMoveForAttackPokemon,
    getMoveDisplayName,
    getMoveDisplayPower,
    calculateDamage,
    getDamageDetail,
    getRankTypeForMove,
    handleUpdateRankCorrection,
    handleSelectTerasuTypeForAttackPokemon,
    handleSelectTerasuStateForAttackPokemon,
    handleSelectItemForAttackPokemon,
    getOffenseItems,
    handleSelectAbilityForAttackPokemon,
    handleUpdateAttackPokemonStats,
    handleUpdateAttackPokemonPersonality,
    handleUpdateAttackPokemonRank,
    onToggleRightSidebar,
    handleRemoveAttackPokemon,
    handleCopyAttackPokemon,
    handleUpdateCriticalHit,
    handleUpdateAttackPokemonStatus,
    handleUpdateCustomPower,
    handleUpdateJuuden,
    handleUpdateDoublePower,
    handleUpdateDefensePokemonEffort,
    currentMode,
    calculateAttackModeDamage,
    getAttackModeDamageDetail,
    isComprehensiveMode,
    comprehensiveOpponents,
    selectedOpponentId,
    comprehensiveUiFlags,
    handleAddComprehensiveOpponent,
    handleSelectComprehensiveOpponent,
    handleRemoveComprehensiveOpponent,
    handleCopyComprehensiveOpponent,
    handleUpdateComprehensiveAssumedMove,
    handleUpdateComprehensiveOtherSetting,
    handleUpdateComprehensiveSpeedSettings,
    handleCreateComprehensiveDefenseProfile,
    handleCreateComprehensiveOffenseProfile,
    setComprehensiveUiFlags,
    handleUpdateComprehensiveProfileStats,
    handleUpdateComprehensiveProfilePersonality,
    handleUpdateComprehensiveProfileRank,
    handleUpdateComprehensiveProfileAbility,
    handleUpdateComprehensiveProfileItem,
    handleUpdateComprehensiveProfileTera,
    handleUpdateComprehensiveKodaiQuarkStat,
    handleUpdateComprehensiveProfileStatus,
  } = vm;
  const canSelectOoame =
    selectedPokemon?.id === POKEMON_ID_KYOGRE_PRIMAL ||
    attackPokemonList?.some((profile: any) => profile?.pokemon?.id === POKEMON_ID_KYOGRE_PRIMAL);
  const canSelectOohidery =
    selectedPokemon?.id === POKEMON_ID_GROUDON_PRIMAL ||
    attackPokemonList?.some((profile: any) => profile?.pokemon?.id === POKEMON_ID_GROUDON_PRIMAL);
  const canSelectRankiryuu =
    selectedPokemon?.id === POKEMON_ID_RAYQUAZA_MEGA ||
    attackPokemonList?.some((profile: any) => profile?.pokemon?.id === POKEMON_ID_RAYQUAZA_MEGA);
  return (
    <Box sx={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: rightSidebarOpen && !isComprehensiveMode ? '80px' : '0px',
      transition: 'padding-bottom 0.1s ease-in-out'
    }}>
      {/* Attack Pokemon List */}
      <Box sx={{
        flex: 1,
        p: 2,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0
      }}>
        {isComprehensiveMode ? (
          <ComprehensiveMode
            selectedPokemon={selectedPokemonForComprehensive ?? selectedPokemon}
            pokemonOptions={pokemonOptions}
            opponents={comprehensiveOpponents}
            selectedOpponentId={selectedOpponentId}
            uiFlags={comprehensiveUiFlags}
            onAddOpponent={handleAddComprehensiveOpponent}
            onSelectOpponent={handleSelectComprehensiveOpponent}
            onRemoveOpponent={handleRemoveComprehensiveOpponent}
            onCopyOpponent={handleCopyComprehensiveOpponent}
            onUpdateAssumedMove={handleUpdateComprehensiveAssumedMove}
            onUpdateOpponentOtherSetting={handleUpdateComprehensiveOtherSetting}
            onUpdateOpponentSpeedSettings={handleUpdateComprehensiveSpeedSettings}
            onCreateDefenseProfile={handleCreateComprehensiveDefenseProfile}
            onCreateOffenseProfile={handleCreateComprehensiveOffenseProfile}
            setUiFlags={setComprehensiveUiFlags}
            currentOtherSetting={currentOtherSetting}
            onOtherSettingChange={onOtherSettingChange}
            calculateAttackModeDamage={calculateAttackModeDamage}
            getAttackModeDamageDetail={getAttackModeDamageDetail}
            calculateDamage={calculateDamage}
            getDamageDetail={getDamageDetail}
            getMoveDisplayName={getMoveDisplayName}
            getMoveDisplayPower={getMoveDisplayPower}
            getOffenseItems={getOffenseItems}
            handleSelectAbilityForAttackPokemon={handleUpdateComprehensiveProfileAbility}
            handleSelectItemForAttackPokemon={handleUpdateComprehensiveProfileItem}
            handleSelectTerasuTypeForAttackPokemon={handleUpdateComprehensiveProfileTera}
            handleUpdateKodaiQuarkStat={handleUpdateComprehensiveKodaiQuarkStat}
            handleUpdateAttackPokemonStats={handleUpdateComprehensiveProfileStats}
            handleUpdateAttackPokemonPersonality={handleUpdateComprehensiveProfilePersonality}
            handleUpdateAttackPokemonRank={handleUpdateComprehensiveProfileRank}
            handleUpdateAttackPokemonStatus={handleUpdateComprehensiveProfileStatus}
          />
        ) : (
        <>
        {currentMode === 'defense' && (
          <DefenceMode
            selectedPokemon={selectedPokemon}
            pokemonOptions={pokemonOptions}
            attackPokemonList={attackPokemonList}
            setAttackPokemonList={setAttackPokemonList}
            selectedAttackPokemonForMove={selectedAttackPokemonForMove}
            setSelectedAttackPokemonForMove={setSelectedAttackPokemonForMove}
            handleAddAttackPokemon={handleAddAttackPokemon}
            getAllAttackMoves={getAllAttackMoves}
            handleSelectMoveForAttackPokemon={handleSelectMoveForAttackPokemon}
            getMoveDisplayName={getMoveDisplayName}
            getMoveDisplayPower={getMoveDisplayPower}
            calculateDamage={calculateDamage}
            getDamageDetail={getDamageDetail}
            getRankTypeForMove={getRankTypeForMove}
            handleUpdateRankCorrection={handleUpdateRankCorrection}
            handleSelectTerasuTypeForAttackPokemon={handleSelectTerasuTypeForAttackPokemon}
            handleSelectTerasuStateForAttackPokemon={handleSelectTerasuStateForAttackPokemon}
            handleSelectItemForAttackPokemon={handleSelectItemForAttackPokemon}
            getOffenseItems={getOffenseItems}
            handleSelectAbilityForAttackPokemon={handleSelectAbilityForAttackPokemon}
            handleUpdateKodaiQuarkStat={vm.handleUpdateKodaiQuarkStat}
            handleUpdateAttackPokemonStats={handleUpdateAttackPokemonStats}
            handleRemoveAttackPokemon={handleRemoveAttackPokemon}
            handleCopyAttackPokemon={handleCopyAttackPokemon}
            handleUpdateCriticalHit={handleUpdateCriticalHit}
            handleUpdateAttackPokemonStatus={handleUpdateAttackPokemonStatus}
            handleUpdateCustomPower={handleUpdateCustomPower}
            handleUpdateJuuden={handleUpdateJuuden}
            handleUpdateDoublePower={handleUpdateDoublePower}
            handleUpdateDefensePokemonEffort={handleUpdateDefensePokemonEffort}
          />
        )}
        
        {currentMode === 'attack' && (
          <OffenceMode
            selectedPokemon={selectedPokemon}
            pokemonOptions={pokemonOptions}
            attackPokemonList={attackPokemonList}
            handleAddAttackPokemon={handleAddAttackPokemon}
            getMoveDisplayName={getMoveDisplayName}
            getMoveDisplayPower={getMoveDisplayPower}
            handleRemoveAttackPokemon={handleRemoveAttackPokemon}
            handleCopyAttackPokemon={handleCopyAttackPokemon}
            calculateAttackModeDamage={calculateAttackModeDamage}
            getAttackModeDamageDetail={getAttackModeDamageDetail}
            currentOtherSetting={currentOtherSetting}
            handleSelectTerasuTypeForAttackPokemon={handleSelectTerasuTypeForAttackPokemon}
            handleSelectItemForAttackPokemon={handleSelectItemForAttackPokemon}
            handleSelectAbilityForAttackPokemon={handleSelectAbilityForAttackPokemon}
            handleUpdateKodaiQuarkStat={vm.handleUpdateKodaiQuarkStat}
            getOffenseItems={getOffenseItems}
            handleUpdateAttackPokemonStats={handleUpdateAttackPokemonStats}
            handleUpdateAttackPokemonPersonality={handleUpdateAttackPokemonPersonality}
            handleUpdateAttackPokemonRank={handleUpdateAttackPokemonRank}
          />
        )}
        
        {currentMode === 'speed' && (
          <SpeedModePage selectedPokemon={selectedPokemon} />
        )}

        {/* Floating Toggle Button when panel is closed */}
        {!rightSidebarOpen && (
          <Box sx={{
            position: 'absolute',
            bottom: 16,
            left: 16,
            zIndex: 1000
          }}>
            <IconButton
              onClick={onToggleRightSidebar}
              sx={{
                backgroundColor: '#1976d2',
                color: 'white',
                width: 40,
                height: 40,
                boxShadow: 2,
                '&:hover': {
                  backgroundColor: '#1565c0',
                  boxShadow: 4
                }
              }}
            >
              ▲
            </IconButton>
          </Box>
        )}
        </>
        )}
      </Box>

      {/* Toggle Button when panel is open - positioned above the panel */}
      {rightSidebarOpen && !isComprehensiveMode && (
        <Box sx={{
          position: 'absolute',
          bottom: 88,
          left: 408,
          zIndex: 1000
        }}>
          <IconButton
            onClick={onToggleRightSidebar}
            sx={{
              backgroundColor: '#1976d2',
              color: 'white',
              width: 40,
              height: 40,
              boxShadow: 2,
              '&:hover': {
                backgroundColor: '#1565c0',
                boxShadow: 4
              }
            }}
          >
            ▼
          </IconButton>
        </Box>
      )}

      {!isComprehensiveMode && (
        <BottomBar
          rightSidebarOpen={rightSidebarOpen}
          currentOtherSetting={currentOtherSetting}
          onOtherSettingChange={onOtherSettingChange}
          canSelectOoame={canSelectOoame}
          canSelectOohidery={canSelectOohidery}
          canSelectRankiryuu={canSelectRankiryuu}
        ></BottomBar>
      )}
    </Box>

  )
}
export default MainDisplay
